import { IDropdownOption } from "office-ui-fabric-react";

export namespace Constants {
    export const ConstraintTypeOptions: IDropdownOption[] = [
        {
            key: 1,
            text: "Week",
        },
        {
            key: 2,
            text: "Month",
        },
        {
            key: 3,
            text: "Year",
        },
    ];
}